import React, { useState } from "react";
import FilterBar from "../../components/filters/FilterBar";
import LiveCompaniesTable from "../../components/table/LiveCompaniesTable";
import "./styles/Companies.css";
import {
  addDocument,
  setDocument,
  getDocument,
  checkUserExists,
} from "../../firebase";
import AddCompanyForm from "../../components/forms/companies/AddCompanyForm";
import PageTitle from "../../components/pageTitle/PageTitle";
import PageTemplate from "../../components/pageTemplate/pageTemplate";
import CompanyStepper from "../../components/steppers/CompanyStepper";

function Companies(props) {
  const [showAddCompany, setAddCompany] = useState(false);

  // creates a new company in firestore and invites the associated admin user
  async function NewCompany(details) {
    try {
      const userInvitedResult = await getDocument(
        "Pending Users/" + details.email
      );
      if (userInvitedResult.success) {
        return { success: false, message: "User already invited" };
      }
      const userExistsResult = await checkUserExists(details.email);
      if (userExistsResult.success) {
        if (userExistsResult.userExists) {
          return { success: false, message: "User already exists" };
        }
      } else {
        return userExistsResult;
      }
      if (
        props.companies.filter(
          (company) => company.trading_name === details.tName
        ).length > 0
      ) {
        return {
          success: false,
          message: "A company with that name already exists",
        };
      }
      // create company document and retrieve auto-generated id
      const addDocResult = await addDocument("Companies", {
        trading_name: details.tName,
        type: details.type,
        num_products: 0,
        num_users: 0,
        apps: 0,
        id: "placeholder",
      });

      if (!addDocResult.success) {
        return addDocResult;
      }
      const companyId = addDocResult.docId;
      // add associated admin user to list of pending users
      const inviteUserResult = await setDocument(
        "Pending Users/" + details.email,
        {
          first_name: details.fName,
          email: details.email,
          role: "company_admin",
          companyId: companyId,
          companyName: details.tName,
          phone: details.phone,
        }
      );
      if (inviteUserResult.success) {
        return { success: true, message: "Company added." };
      } else {
        return inviteUserResult;
      }
    } catch (error) {
      return { success: false, message: error.message };
    }
  }


  return (
    <PageTemplate navigate={showAddCompany ? props.navigate : null}>
      <div className="quick-buttons">
        <PageTitle
          text="Companies "
          confirmNav={true}
          links={[
            { url: "/", text: "Home | " },
            { url: "/companies", text: "Companies" },
          ]}
        />
        <button
          className="add-company-button"
          onClick={() => setAddCompany(true)}
        >
          Add Company
        </button>
      </div>
      {/* <div className="filter-bar-container">
        <FilterBar />
        <div className="underline-flex"> </div>
      </div> */}
      {showAddCompany && (
        <AddCompanyForm onAddCompany={NewCompany} showElement={setAddCompany} />
      )}
      <LiveCompaniesTable
        companies={props.companies}
      />
      <div className="home-widgets"></div>
    </PageTemplate>
  );
}
export default Companies;
